import script from "./xt_footer.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_footer.vue?vue&type=script&setup=true&lang=js"

import "./xt_footer.vue?vue&type=style&index=0&id=7a45e0e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a45e0e0"]])

export default __exports__